<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('fertilization.fertilizer_cycles_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.year') }}:</strong>
                        </h6>
                        {{ rowData.year }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('fertilization.cycles_number') }}:</strong
                          >
                        </h6>
                        {{ rowData.number_cycles }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.initial_date') }}:</strong
                          >
                        </h6>
                        {{ rowData.initial_date }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.final_date') }}:</strong>
                        </h6>
                        {{ rowData.end_date }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.company') }}:</strong>
                        </h6>
                        <span v-if="rowData.business">{{
                          rowData.business.name
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.user') }}:</strong>
                        </h6>
                        <span v-if="rowData.user"
                          >{{ rowData.user.first_name }}
                          {{ rowData.user.last_name }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            v-if="isCreate()"
            :title="title"
            :visible.sync="modals.create"
          >
            <form>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.select_a_company') }} *</label
                    >
                    <br />
                    <el-select
                      clearable
                      class="select-primary custom-width-select bus-rels shadow-sm"
                      size="large"
                      v-model="fertilizationCycleForm.business_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      filterable
                    >
                      <el-option
                        v-for="option in businesses"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="option.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>{{ $t('common_words.year') }} *</label>
                  <el-date-picker
                    v-if="renderComponent"
                    class="fer-year"
                    v-model="fertilizationCycleForm.year"
                    type="year"
                    :disabled="disabledYear"
                    @change="validateCycleExists"
                    :placeholder="$t('common_words.year_selection')"
                  >
                  </el-date-picker>
                </div>
                <div class="col-6" v-if="!edit">
                  <fg-input
                    ref="number_cycles"
                    min="1"
                    type="number"
                    :disabled="disabledCycles"
                    :label="`${$t('fertilization.cycles_number')}: *`"
                    v-model="fertilizationCycleForm.number_cycles"
                    v-validate="modelValidations.number_cycles"
                    name="fertilization.cycles_number_lowercase"
                    :error="
                      getError('fertilization.cycles_number_lowercase', true)
                    "
                  >
                  </fg-input>
                </div>
                <div v-else class="col-6">
                  <div class="form-group has-label" v-if="renderComponent">
                    <label class="label-primary">{{
                      $t('common_words.initial_and_final_date')
                    }}</label>
                    <el-date-picker
                      v-if="renderComponent"
                      v-model="fertilizationCycleForm.date"
                      type="daterange"
                      :start-placeholder="$t('common_words.initial_date')"
                      :end-placeholder="$t('common_words.final_date')"
                      @input="forceRerender"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div v-if="!edit">
                <div
                  class="row"
                  v-for="index in Number(fertilizationCycleForm.number_cycles)"
                  :key="index"
                >
                  <div class="col-12">
                    <div class="form-group has-label">
                      <label class="label-primary"
                        >{{ $t('fertilization.initial_and_final_cycle') }}
                        {{ index + aux }}</label
                      >
                      <el-date-picker
                        v-if="renderComponent"
                        class="fer-date"
                        v-model="dates[index - 1]"
                        type="daterange"
                        :start-placeholder="$t('common_words.initial_date')"
                        :end-placeholder="$t('common_words.final_date')"
                        @change="validateDates(index - 1)"
                        :clearable="false"
                        :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="row" v-show="errorAlert">
              <div class="col-lg-12">
                <br />
                <el-alert
                  ref="error_alert"
                  :title="$t('common_words.errors')"
                  type="error"
                  >{{ error }}</el-alert
                >
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              height="530"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import mixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import configTable from './fertilizationCycleTable';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';
import i18n from 'src/i18n';

export default {
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      fertilizationCycleForm: {
        number_cycles: 0,
        year: null,
        business_id: null,
      },
      dates: [],
      modelValidations: {
        number_cycles: {
          required: true,
        },
      },
      pagination: {},
      tableColumns: [],
      businesses: null,
      index_exclude: null,
      edit: false,
      continue: false,
      aux: 0,
      disabledCycles: true,
      disabledYear: false,
      fertilization_cycles_dates: [],
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    mixinDatePicker,
    MixinForm,
    MixinNotification,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'setupTable'],
  },

  methods: {
    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('fertilization.fertilizer_cycles_add');
        this.edit = false;
        this.$validator.reset();
        this.fertilizationCycleForm = {
          number_cycles: null,
          year: null,
          date: null,
          business_id: null,
        };
        this.disabledYear = false;
        this.disabledCycles = true;
        this.dates = [];
      }

      this.modals[name] = true;
    },

    closeModal(name) {
      this.aux = 0;
      this.continue = false;
      this.modals[name] = false;
    },

    validateCycleExists() {
      this.fertilization_cycles_dates = [];

      let year = this.fertilizationCycleForm.year.getFullYear();
      let aux = 0;
      let find = false;

      this.tableData.forEach((elem) => {
        if (elem.year == year) {
          find = true;

          if (
            elem.end_date == year + '-12-31' &&
            elem.business_id == this.fertilizationCycleForm.business_id &&
            !this.edit
          ) {
            this.showError(
              'fer-date',
              'error-date',
              i18n.t('show_notification.fertilization.year_cycles_registered')
            );
            this.fertilizationCycleForm.year = null;
            this.disabledCycles = true;
          } else {
            this.disabledCycles = false;
          }

          if (
            elem.number_cycles > aux &&
            elem.business_id == this.fertilizationCycleForm.business_id
          ) {
            aux = elem.number_cycles;
          }

          if (elem.business_id == this.fertilizationCycleForm.business_id) {
            this.fertilization_cycles_dates.push([
              elem.initial_date,
              elem.end_date,
            ]);
          }
        }
      });

      if (!find) {
        this.disabledCycles = false;
      }

      this.aux = aux;
      this.continue = this.fertilization_cycles_dates.length > 0 ? true : false;
    },

    validateDates(index) {
      let year = this.fertilizationCycleForm.year.getFullYear();

      if (
        this.dates[index][0].getFullYear() != year &&
        this.dates[index][1].getFullYear() != year
      ) {
        this.showError(
          'fer-date',
          'error-date',
          i18n.t('show_notification.fertilization.unable_input_date_year')
        );

        setTimeout(() => {
          this.dates[index].splice(0, 1);
          this.dates[index].splice(1, 1);
        }, 1000);
      }

      if (index != 0) {
        if (this.dates[index][0] <= this.dates[index - 1][1]) {
          this.showError(
            'fer-date',
            'error-date',
            i18n.t(
              'show_notification.fertilization.inputed_dates_ranges_outofbound'
            )
          );
        }
      }
    },

    validateAllDates() {
      if (this.continue == true) {
        let dates = Object.assign([], this.fertilization_cycles_dates);
        let thisdates = [];

        if (this.edit == true && this.index_exclude != true) {
          let elem = this.fertilizationCycleForm.date;
          dates[this.index_exclude] = [
            moment(String(elem[0])).format('YYYY-MM-DD'),
            moment(String(elem[1])).format('YYYY-MM-DD'),
          ];
        } else {
          this.dates.forEach((elem) => {
            thisdates.push([
              moment(String(elem[0])).format('YYYY-MM-DD'),
              moment(String(elem[1])).format('YYYY-MM-DD'),
            ]);
          });

          dates = dates.concat(thisdates);
        }

        for (let index = 1; index < dates.length; index++) {
          if (dates[index][0] <= dates[index - 1][1]) {
            this.showError(
              'fer-date',
              'error-date',
              i18n.t('show_notification.fertilization.unable_to_include_dates')
            );
            return false;
          }
        }
      } else {
        for (let index = 1; index < this.dates.length; index++) {
          if (this.dates[index][0] <= this.dates[index - 1][1]) {
            this.showError(
              'fer-date',
              'error-date',
              i18n.t('show_notification.fertilization.outofbounds_dates_ranges')
            );
            return false;
          }
        }
      }

      return true;
    },

    validate() {
      if (this.fertilizationCycleForm.year == null) {
        this.showError(
          'fer-year',
          'error-date',
          i18n.t('show_notification.fertilization.fill_dates')
        );
      } else {
        return this.$validator.validateAll().then((isValid) => {
          if (isValid && this.validateAllDates() == true) {
            if (this.fertilizationCycleForm.business_id == null) {
              for (let index of document.getElementsByClassName('bus-rels')) {
                let sel = index.getElementsByClassName('el-input__inner')[0];
                sel.focus();
                sel.classList.add('custom-has-error');
                store.dispatch('utils/removeHasError', sel);
              }
              return false;
            } else if (
              (!this.edit &&
                (this.dates.length == 0 ||
                  this.dates.length !=
                    this.fertilizationCycleForm.number_cycles)) ||
              (this.edit && this.fertilizationCycleForm.date == null)
            ) {
              this.showError(
                'fer-date',
                'error-date',
                i18n.t('show_notification.fertilization.fill_dates')
              );
              return false;
            } else {
              this.addEditFertilizationCycle();
            }
          }
        });
      }
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('fertilization.fertilizer_cycles_edit') + ' ';
      row.year + ' - ' + row.number_cycles;
      this.fertilizationCycleForm = Object.assign({}, row);
      this.fertilizationCycleForm.year = new Date(
        this.fertilizationCycleForm.year,
        0,
        1
      );
      this.fertilizationCycleForm.route = 'fertilization/fertilization_cycles';
      this.fertilizationCycleForm.date = [
        moment(row.initial_date),
        moment(row.end_date),
      ];
      this.errors.clear();

      this.edit = true;
      this.disabledYear = true;
      this.validateCycleExists();
      let index1 = this.fertilization_cycles_dates.findIndex(
        (cycle) => cycle[0] === row.initial_date && cycle[1] === row.end_date
      );
      this.index_exclude = index1;
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.fertilizationCycleForm = row;
      let name =
        '[' +
        this.fertilizationCycleForm.initial_date +
        ',  ' +
        this.fertilizationCycleForm.end_date +
        ']';
      SweetAlert.delete(
        `'${i18n.t('fertilization.the_fertilization_cycle')}   ${name}`
      ).then((result) => {
        if (result.value) this.deleteFertilizationCycle();
      });
    },

    addEditFertilizationCycle() {
      this.showHideLoading(true);

      this.fertilizationCycleForm.aux = this.aux;

      if (
        this.fertilizationCycleForm.route ==
        'fertilization/fertilization_cycles'
      ) {
        if (this.isUpdate()) {
          Axios.updateMaster(this.fertilizationCycleForm)
            .then((response) =>
              this.modifyTable(1, this.fertilizationCycleForm.id, response)
            )
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        this.fertilizationCycleForm.dates = this.dates;

        if (this.isCreate()) {
          this.fertilizationCycleForm.route =
            'fertilization/fertilization_cycles';
          Axios.saveMaster(this.fertilizationCycleForm)
            .then((response) => {
              response.data.data.forEach((elem) => {
                this.tableData.push(elem);
              });

              this.closeModal('create');
              this.showNotification(
                `${response.data.message}`,
                'success',
                'nc-simple-add',
                i18n.t('common_words.successful_creation_threedots')
              );
              this.showHideLoading();
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteFertilizationCycle() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.fertilizationCycleForm.route =
          'fertilization/fertilization_cycles';
        Axios.destroyMaster(this.fertilizationCycleForm)
          .then((response) =>
            this.modifyTable(2, this.fertilizationCycleForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'fertilization/fertilization_cycles/pdf';
      data.name_file = `${i18n.t('fertilization.fertilizer_cycles')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'fertilization/fertilization_cycles/excel';
      data.name_file = `${i18n.t('fertilization.fertilizer_cycles')}.xslx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      // Assign the Table and Search objects to your data properties
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('fertilization/fertilization_cycles')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = response.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
